module.exports = __webpack_public_path__ + "static/media/user-icon.a131f901.svg";